import 'firebase/compat/firestore'

import firebase from 'firebase/compat/app'
import moment from 'moment-timezone'
import { notificationType } from '../types/app_release'

export default class AppRelease {
  private _id: string
  private _data: {
    notification_type: string
    notify: boolean
    release_date: firebase.firestore.Timestamp
    release_note: string
    version: string
    title: string
  }
  private _ref: firebase.firestore.DocumentReference

  constructor(snapshot?: firebase.firestore.DocumentSnapshot) {
    if (snapshot) {
      this._id = snapshot.id
      this._ref = snapshot.ref
      this._data = snapshot.data() || {}
    } else {
      this._data = {
        notification_type: '',
        notify: false,
        release_date: new Date() as firebase.firestore.Timestamp,
        release_note: '',
        version: '',
        title: '',
      }
    }
  }

  public static collectionRef() {
    return firebase.firestore().collection('app_release')
  }

  public static listenToReleases(releaseDate: moment.Moment) {
    const releaseDateTimestamp = firebase.firestore.Timestamp.fromDate(releaseDate.toDate())
    return AppRelease.collectionRef()
      .where('release_date', '>', releaseDateTimestamp)
      .where('notify', '==', true)
      .orderBy('release_date', 'desc')
      .limit(2)
  }

  static listenToHotFixes(releaseDate: moment.Moment) {
    const releaseDateTimestamp = firebase.firestore.Timestamp.fromDate(releaseDate.toDate())
    return AppRelease.collectionRef()
      .where('release_date', '>', releaseDateTimestamp)
      .where('notification_type', '==', notificationType.BUG_FIX)
      .where('notify', '==', true)
      .orderBy('release_date', 'desc')
      .limit(1)
  }

  public static ignoreListCollectionRef() {
    return firebase.firestore().collection('app_release_ignore_list')
  }

  public static async isIgnored(companyId: string, userId: string): Promise<boolean> {
    try {
      if(!companyId) {
        return false;
      }
      const data = await AppRelease.ignoreListCollectionRef()
        .where('company_id', '==', companyId)
        .where('hidden_criteria', 'in', ['ALL', 'SELECTED_USERS'])
        .get();
      const isVisible = data.docs.some((doc) => {
        const docData = doc.data();
        return docData.hidden_criteria === 'ALL' || 
               (docData.hidden_criteria === 'SELECTED_USERS' && docData.selected_users.includes(userId));
      });
      return isVisible;
    } catch {
      return false; 
    }
  }

  get id(): string | undefined {
    return this._id
  }

  get data(): firebase.firestore.DocumentData {
    return this._data
  }

  get version(): string {
    return this._data.version
  }

  get releaseNotes(): string {
    return this._data.release_note
  }

  get releaseDate(): string {
    return moment(this._data.release_date.toMillis()).format('YYYY-MM-DD HH:mm')
  }

  get notificationType(): string {
    return this._data.notification_type
  }

  get notify(): boolean {
    return this._data.notify
  }
}
